import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { color } from '~/assets/styles/colors';
import ReactGA from 'react-ga4';
import { IoHomeOutline } from "react-icons/io5";
import { SlPeople } from "react-icons/sl";
import { FaArrowTrendUp, FaCalculator } from "react-icons/fa6";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdPriceCheck, MdFileDownload } from "react-icons/md";
import { TiAttachmentOutline } from "react-icons/ti";
import { RiNodeTree, RiMoneyDollarBoxLine, RiMoneyDollarCircleLine  } from "react-icons/ri";
import { CiCirclePlus, CiCircleQuestion  } from "react-icons/ci";
import { TfiWrite } from "react-icons/tfi";
import Notification from '~/components/Header/Notification';
import Perfil from '~/components/Header/Perfil';

import { Row } from 'reactstrap';
import history from '../../../../services/history';
import PdfChargBack from '../../../../assets/pdf/PoliticaChargeback.pdf';
import PdfContrato from '../../../../assets/pdf/ContratoDeCredenciamentoEAdesaoDeEstabelecimentos.pdf';
import {
	ContainerFooter,
	ContentFooter,
	ImgDivFooter,
	TextFooter,
	TextDivFooter,
	ContainerMenu,
	Container,
	ContentMenuItem
} from './styles';



function Client(props) {
	const {notificacoes, dataNotification} = props;
	const { user } = useSelector((state) => state.auth);
	const [isMenuActive, setIsMenuActive] = useState(false);
	const [dropdownOpenNotificacao, setDropdownOpenNotificacao] = useState(false);
	const [dropdownOpenPerfil, setDropdownOpenPerfil] = useState(false);

	const currentPath = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);

	const isIndustria = user.dados.cargo.toLowerCase() === 'industria';

	let label = 'Distribuidores';

	if (user.dados.permissoes.view_credito_revenda_distribuidor) {
		if (user.dados.permissoes.view_farmacias) {
			label = 'Farmácias';
		} else {
			label = isIndustria ? 'Distribuidores' : 'Revendedores';
		}
	}

	const linksSubMebuToMap=[
		{
			nome: 'Home',
			messageGA4: 'acessar_home_menu_mobile',
			alt: 'home',
			to: user.dados.permissoes.view_dashboard ? '/client/dashboard' : '/client/transacoes',
			image: <IoHomeOutline size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: true
		},
		{
			nome: 'Meus Pedidos',
			messageGA4: 'acessar_pedidos_menu_mobile',
			alt: 'meusPedidos',
			to: '/client/transacoes/pedidos',
			image: <RiMoneyDollarBoxLine size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_meus_pedidos
		},
		{
			nome: 'Distribuidores',
			messageGA4: 'acessar_distribuidores_menu_mobile',
			alt: 'distribuidores',
			to: '/client/transacoes/autorizar',
			image: <RiMoneyDollarBoxLine size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_autorizar_credito_revenda
		},
		{
			nome: 'Revendas',
			messageGA4: 'acessar_revendas_menu_mobile',
			alt: 'revendas',
			to: '/client/transacoes/consultaRevendas',
			image: <RiNodeTree size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_autorizar_credito_parceiro
		},
		{
			nome: 'Filiais',
			messageGA4: 'acessar_filiais_menu_mobile',
			alt: 'filiais',
			to:  '/client/transacoes/filiais',
			image: <RiNodeTree size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_filiais
		},
		{
			nome: 'Lançamentos',
			messageGA4: 'acessar_lancamentos_menu_mobile',
			alt: 'lancamentos',
			to: '/client/transacoes/lancamentos',
			image: <CiCirclePlus size={29} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_lancamentos
		},
		{
			nome: (user.dados.permissoes.view_labels_pgm_triplo && user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') ? 'Extrato de Créditos Revendas' :  'Extrato de Créditos',
			messageGA4: 'acessar_extrato_menu_mobile',
			alt: 'extratoCreditos',
			to: '/client/transacoes/extrato',
			image: <RiMoneyDollarCircleLine size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_extrato_credito
		},
		{
			nome: 'Meu Extrato de Crédito',
			messageGA4: 'acessar_extrato_menu_mobile',
			alt: 'extratoDistribuidor',
			to: '/client/transacoes/extratoDistribuidor',
			image: <RiMoneyDollarCircleLine size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: (user.dados.permissoes.view_extrato_credito && user.dados.permissoes.view_labels_pgm_triplo && user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor')
		},
		{
			nome: 'Vendas',
			messageGA4: 'acessar_vendas_menu_mobile',
			alt: 'vendas',
			to: '/client/transacoes/vendas',
			image: <RiMoneyDollarCircleLine size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_vendas
		},
		{
			nome: 'Recebimentos',
			messageGA4: 'acessar_recebimentos_menu_mobile',
			alt: 'recebimentos',
			to: '/client/transacoes/recebimentos',
			image: <MdPriceCheck size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_recebimentos
		},
		{
			nome: label,
			messageGA4: `acessar_${label}_2_menu_mobile`,
			alt: `${label}2`,
			to: '/client/transacoes/credRevenda',
			image: <SlPeople size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_credito_revenda_distribuidor || user.dados.permissoes.view_credito_parceiro
		},
		{
			nome: 'Resumo',
			messageGA4: 'acessar_resumo_menu_mobile',
			alt: 'resumo',
			to: '/client/transacoes/resumo',
			image: <TfiWrite size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.detalhamento_financeiro_revenda || user.dados.permissoes.detalhamento_financeiro_participante || user.dados.permissoes.detalhamento_financeiro_industria
		},
		{
			nome: 'Simulador',
			messageGA4: 'acessar_simulador_menu_mobile',
			alt: 'simulador',
			to: '/client/simulador',
			image: <FaCalculator size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.permissoes.view_simulador
		},
		{
			nome: 'Link de pagamento',
			messageGA4: 'acessar_link_menu_mobile',
			alt: 'linkPagamento',
			to: '/client/maquina-virtual',
			image: <TiAttachmentOutline size={27} color={color.secondary} />,
			link: true,
			notLinkFunction: () => {},
			status: user.dados.simulador_virtual
		},
		{
			nome: 'FAQ',
			messageGA4: 'acessar_faq_menu_mobile',
			alt: 'faq',
			to: '',
			link: false,
			notLinkFunction: () => {handlerFaqLink()},
			image: <CiCircleQuestion size={33} color={color.secondary} />,
			status: true
		},
		{
			nome: 'Termo',
			messageGA4: 'download_termo_menu_mobile',
			alt: 'termo',
			to: '',
			link: false,
			notLinkFunction: () => {
				handleDownload('termo')},
			image: <MdFileDownload size={27} color={color.secondary} />,
			status: true
		},
		{
			nome: 'Contrato',
			messageGA4: 'download_contrato_menu_mobile',
			alt: 'contrato',
			to: '',
			link: false,
			notLinkFunction: () => {handleDownload('contrato')},
			image: <MdFileDownload size={27} color={color.secondary} />,
			status: true
		}
	];

	const linksToMap = [
		{
			nome: 'Home',
			alt: 'home',
			to: user.dados.permissoes.view_dashboard ? '/client/dashboard' : '/client/transacoes',
			image: <IoHomeOutline size={24} color={color.secondary} />,
			isModal: false,
			link: true,
			notLinkFunction: () => {
				searchParams.delete('modalOn');
				history.push({
				pathname: currentPath,
				search: searchParams.toString()
				});
			},
			status: true
		},
		{
			nome: 'Portal',
			alt: 'transacoes',
			to: user.dados.permissoes.view_vendas ? '/client/transacoes/vendas' : '/client/transacoes',
			image: <FaArrowTrendUp size={24} color={color.secondary} />,
			isModal: false,
			link: true,
			notLinkFunction: () => {
				searchParams.delete('modalOn');
				history.push({
				pathname: currentPath,
				search: searchParams.toString()
				});
			},
			status: true
		},
		{
			nome: '',
			alt: 'menu',
			to: '',
			link: false,
			isModal: false,
			notLinkFunction: () => {
				setIsMenuActive(!isMenuActive);
				searchParams.set('modalOn', isMenuActive);
				history.push({
				pathname: currentPath,
				search: searchParams.toString()
				});
			},
			image: <div className={`${isMenuActive ? 'menu-active' : 'menu-icon'}`}><GiHamburgerMenu size={22} /></div> ,
			status: true
		},
		{
			nome: 'Notificações',
			alt: 'notificacoes',
			to: '',
			isModal: true,
			image: <Notification dropdownOpen={dropdownOpenNotificacao} setDropdownOpen={setDropdownOpenNotificacao} color={color.secondary} notificacoes={notificacoes} dataNotification={dataNotification} />,
			link: false,
			notLinkFunction: () => {
				setIsMenuActive(false);
				searchParams.set('modalOn', dropdownOpenNotificacao);
				history.push({
				pathname: currentPath,
				search: searchParams.toString()
				});
			},
			status: user.dados.permissoes.view_notificacoes
		},
		{
			nome: 'Perfil',
			alt: 'perfil',
			to: '',
			isModal: true,
			image: <Perfil dropdownOpen={dropdownOpenPerfil} setDropdownOpen={setDropdownOpenPerfil} color={color.secondary} />,
			link: false,
			notLinkFunction: () => {
				setIsMenuActive(false);
				searchParams.set('modalOn', dropdownOpenPerfil);
				history.push({
				pathname: currentPath,
				search: searchParams.toString()
				});
			},
			status: true
		}
	];


	function handlerFaqLink() {
		setIsMenuActive(false)
		const url = "https://lucree.com.br/fale-conosco/";
		window.open(url, '_blank');
	}


	const handleDownload = (tabAtiva) => {
		fetch(tabAtiva === 'termo' ? PdfChargBack : PdfContrato)
			.then(response => response.blob())
			.then(blob => {
				setIsMenuActive(false)
				const fileURL = window.URL.createObjectURL(blob);
				const alink = document.createElement('a');
				alink.href = fileURL;

				const nomeArquivo = tabAtiva === 'termo' ? 'Termo_Lucree.pdf' : 'Contrato_Lucree.pdf';
				alink.download = nomeArquivo;

				alink.click();
			});
	}

	function linkPage(to) {
		history.push(to);
		setIsMenuActive(false);
	}


	function handleClickEventGA4(message) {
		ReactGA.event({
			category: message,
			action: message,
			label: message,
		});
	}

	return (
		<Container>
			{isMenuActive &&
				<ContainerMenu className='container-menu'>
					<Row xs="12" md="12" lg="12">
						{linksSubMebuToMap.length > 0 &&
							linksSubMebuToMap.map(item => (
								item.status &&
								<ContentMenuItem
									md="3"
									lg="3"
									xs="3"
									key={item.nome}
									onClick={() => {
										if(item.link){
											linkPage(item.to)

										}else{
											item.notLinkFunction()
										}
										if(item.messageGA4){
											handleClickEventGA4(item.messageGA4)
										}
									}}>
								{item.isModal
								?
									item.image
								:
									<ImgDivFooter>
										{item.image}
									</ImgDivFooter>
								}

									{item.nome &&
										<TextDivFooter>
											<TextFooter>
												{item.nome}
											</TextFooter>
										</TextDivFooter>
									}
								</ContentMenuItem>
							))
						}
					</Row>
				</ContainerMenu>
			}
			<ContainerFooter>
				{linksToMap.map(item => (
					item.status &&
					<ContentFooter onClick={() => {
						if(item.link){
							linkPage(item.to)
						}else{
							item.notLinkFunction()
						}
					}}>
						<ImgDivFooter>
							{item.image}
						</ImgDivFooter>
						{item.nome &&
							<TextDivFooter>
								<TextFooter>
									{item.nome}
								</TextFooter>
							</TextDivFooter>
						}
					</ContentFooter>
					// </Link>
				))}
			</ContainerFooter>
		</Container>
	);
}

export default Client;

/* {linksToMap.map(item => (
	item.status &&
	<LinkContainer>
		<LinkFooter to={item.to}>
			<ImgFooter
				alt={item.alt}
				width="25"
				src={item.image}
			/>
		</LinkFooter>
	</LinkContainer>
))}
{linksToMap.map(item => (
	item.status &&
	<LinkContainer>
		<DivTextFooter>
			<Text size={25}>{item.nome}</Text>
		</DivTextFooter>
	</LinkContainer>
))}
 <LinkFooter to={(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && projetos.includes(user.dados.tipo_projeto.toLowerCase()))
? '/client/transacoes'
: '/client/dashboard'}>
<HomeOutlined />
Dashboard
</LinkFooter> */
